<template>
  <b-container fluid>
    <!-- <b-breadcrumb style="background-color:#f8f9fa" :items="itemsBreadcrumb"></b-breadcrumb> -->

    <b-row>
      <b-col cols="9" class="p-3">
        <b-tabs class="shadow-sm">
          <b-tab title="ACTION REQUIRED" class="p-4 bg-white" style="height:calc(100vh - 170px);">
            <b-overlay :show="isLoading" rounded="sm">
              <b-navbar toggleable="lg" type="dark" variant="light">
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <b-navbar-brand href="#" class="text-dark">
                  <strong>Actions Required</strong>
                </b-navbar-brand>

                <b-collapse id="nav-collapse" is-nav>
                  <b-navbar-nav class="ml-auto">
                    <b-nav-form>
                      <b-button variant="outline-info" size="sm" class="mr-2" @click="reloadTable">
                        <font-awesome-icon icon="sync" />
                      </b-button>
                      <b-form-group>
                        <b-input-group size="sm">
                          <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-nav-form>
                  </b-navbar-nav>
                </b-collapse>
              </b-navbar>
              <b-table
                small
                class="mx-1"
                sticky-header="calc(100vh - 360px)"
                ref="table"
                bordered
                id="users-data-table"
                :busy.sync="isLoading"
                :items="getOnboardingTaskData"
                :fields="staticFields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                responsive="sm"
                no-sort-reset
              >
                <template v-slot:cell(created_at)="data">
                  <p>{{ createdAtDate(data.item.created_at) }}</p>
                </template>
                <template v-slot:cell(task_title)="data">
                  <a :href="'/emplyee-user-form/'+data.item.id+'/2'">{{data.item.task_title}}</a>
                </template>
                <template v-slot:cell(task_status)="data">
                  <b-badge v-if="data.item.task_status == '0'" variant="info">Open</b-badge>
                  <b-badge v-if="data.item.task_status == '1'" variant="warning">In Progress</b-badge>
                  <b-badge v-if="data.item.task_status == '2'" variant="danger">On hold</b-badge>
                  <b-badge v-if="data.item.task_status == '3'" variant="dark">Review</b-badge>
                  <b-badge v-if="data.item.task_status == '4'" variant="success">Complete</b-badge>
                </template>
                <!-- <template v-slot:cell(view_button)="data">
                  <b-btn
                    :to="'/emplyee-user-form/'+data.item.id+'/2'"
                    size="sm"
                    variant="outline-info"
                  >
                    <font-awesome-icon icon="eye" />
                  </b-btn>
                </template>-->
              </b-table>
              <p class="text-center mt-3">
                Showing Result From
                <b>{{fromRows}}</b> to
                <b>{{toRows}}</b>
              </p>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="users-data-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-overlay>
          </b-tab>
          <b-tab title="MY ONBOARDINGS" class="bg-white">
            <MyOnboardingComponent />
          </b-tab>
          <!-- <b-tab title="Gifts">
              <ApprovalsTab :managerDashboard="true" />
          </b-tab>-->
        </b-tabs>
      </b-col>
      <b-col cols="3">
        <b-card header-tag="header">
          <template v-slot:header>
            <h6 class="text-left">Activity</h6>
          </template>
          <b-card-body class="scrollFlow" style="height: 400px; overflow: hidden auto;">
            <ul class="timeline">
              <li>
                <p class="text-muted">16 June, 2020 - 15:49:26</p>
                <p class="text-muted">Onboarding request has been sent to the Third Party.</p>
              </li>
              <li>
                <p class="text-muted">16 June, 2020 - 15:49:26</p>
                <p class="text-muted">Third Party saved by ethiXbase.</p>
              </li>
              <li>
                <p class="text-muted">16 June, 2020 - 15:49:26</p>
                <p class="text-muted">Instant Due Diligence Report generated by ethiXbase.</p>
              </li>
            </ul>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { HTTP } from "../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import MyOnboardingComponent from "../../components/newEmployeeComponents/managerDashboardComponents/myOnboardingComponent.vue";
export default {
  name: "ManagerDashboard",
  components: {
    MyOnboardingComponent,
  },
  data() {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "#",
          active: true,
        },
      ],
      isLoading: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "worflow", label: "Workflow", sortable: true },
        { key: "task_title", label: "Task Title", sortable: true },
        // { key: "title", label: "Form Title", sortable: true },
        { key: "task_status", label: "Status", sortable: true },
        // { key: "view_button", label: "Action", sortable: false },
      ],
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  methods: {
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::data", "users-data-table");
    },
    async getOnboardingTaskData() {
      let employeeId = localStorage.getItem("employeeId");
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP(
        "post",
        "api/v1/onboarding/employee/tasks/table/" + employeeId,
        formData,
        {
          Authorization: token,
        }
      );

      return result
        .then((response) => {
          const items = response.data.data;
          this.isLoading = false;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          this.totalRows = response.data.total;
          return items;
        })
        .catch((error) => {
          this.isLoading = false;
          return [error];
        });
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
</style>